import 'css-chunksrc/client/common/projectsSelection/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_1pv57_1",
  "checked": "_checked_1pv57_12"
};